import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import siteQueries from '../../queries/siteQueries';
import { useNavigate } from 'react-router-dom';
import paymentService from '../../services/paymentService';
import PenLogo from '../../images/logo/delegate-button-icon.png';
import RouteConstants from '../../constant/Routeconstant';


const DelegateRegistration = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [formData, setFormData] = useState({
        full_name: '',
        date_of_birth: '',
        gender: '',
        nationality: '',
        occupation: '',
        educational_institution: '',
        postal_address: '',
        mobile_number: '',
        email: '',
        delegate_category: '',
        id_proof: null,
        role: 'DELEGATE'
    });

      const navigate = useNavigate();
    
    // const [errors, setErrors] = useState({});
    //   const qrCreate = siteQueries.useQrcreateMutation(async (response) => {
    //   });

    // const slides = [
    //     {
    //         id: 1,
    //         title: "Personal Information",
    //         fields: ['full_name', 'date_of_birth', 'gender']
    //     },
    //     {
    //         id: 2,
    //         title: "Professional Details",
    //         fields: ['nationality', 'occupation', 'educational_institution']
    //     },
    //     {
    //         id: 3,
    //         title: "Contact Information",
    //         fields: ['postal_address', 'mobile_number', 'email']
    //     },
    //     {
    //         id: 4,
    //         title: "Registration Type",
    //         fields: ['delegate_category', 'id_proof']
    //     }
    // ];

    // const validateForm = () => {
    //     const newErrors = {};

    //     // Required fields validation
    //     if (!formData.full_name.trim()) newErrors.full_name = 'Full name is required';
    //     if (!formData.date_of_birth.trim()) newErrors.date_of_birth = 'Date of birth is required';
    //     if (!formData.mobile_number.trim()) newErrors.mobile_number = 'Mobile number is required';
    //     if (!formData.delegate_category) newErrors.delegate_category = 'Delegate category is required';
    //     // if (formData.delegate_category === 'STUDENT' && !formData.id_proof) {
    //     //     newErrors.id_proof = 'Student ID is required for student category';
    //     // }

    //     // Format validation
    //     if (formData.mobile_number && !/^\+?[\d\s\-\(\)]{10,}$/.test(formData.mobile_number)) {
    //         newErrors.mobile_number = 'Please enter a valid phone number';
    //     }
    //     if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //         newErrors.email = 'Please enter a valid email address';
    //     }

    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData(prev => ({ ...prev, [name]: value }));
    //     if (errors[name]) {
    //         setErrors(prev => ({ ...prev, [name]: '' }));
    //     }
    // };

    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         setFormData(prev => ({ ...prev, id_proof: file }));
    //         if (errors.id_proof) {
    //             setErrors(prev => ({ ...prev, id_proof: '' }));
    //         }
    //     }
    // };

    // const nextSlide = () => {
    //     // Validate only required fields for current slide
    //     const currentSlideFields = slides[currentSlide].fields;
    //     const slideErrors = {};

    //     currentSlideFields.forEach(field => {
    //         // Only validate these fields as required
    //         const requiredFields = ['full_name', 'date_of_birth', 'mobile_number', 'delegate_category'];
    //         if (requiredFields.includes(field) && !formData[field]) {
    //             slideErrors[field] = 'This field is required';
    //         }

    //         // Format validation
    //         if (field === 'mobile_number' && formData.mobile_number && !/^\+?[\d\s\-\(\)]{10,}$/.test(formData.mobile_number)) {
    //             slideErrors.mobile_number = 'Please enter a valid phone number';
    //         }
    //         if (field === 'email' && formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    //             slideErrors.email = 'Please enter a valid email address';
    //         }
    //     });

    //     if (Object.keys(slideErrors).length > 0) {
    //         setErrors(prev => ({ ...prev, ...slideErrors }));
    //         return;
    //     }

    //     setCurrentSlide(prev => (prev + 1) % slides.length);
    // };

    // const prevSlide = (formData) => {
    //     setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
    // };


    // const useDelegateCreate = siteQueries.useDelegateCreateMutation(
    //     async (response) => {
    //         console.log(response);
    //         if (response.message === 'User created successfully') {
    //          const qrcode =  await qrCreate.mutateAsync({id:response?.data?.user?.id});
    //       sessionStorage.setItem('qrdata', JSON.stringify(qrcode));
    //       navigate('/atsuccess');

    //             console.log("Registration successful");
    //             setFormData({
    //                 username: '',
    //                 first_name: '',
    //                 last_name: '',
    //                 email: '',
    //                 age: '',
    //                 phone: '',
    //                 gender: '',
    //                 pin_code: '',
    //                 platform: null,
    //                 country: '',
    //                 state: null,
    //                 district: null,
    //                 dob: '',
    //                 address: '',
    //                 content: null,
    //                 marketing_id: null,
    //                 role: 'DELEGATE',
    //             });
    //             onClose();
    //         }
    //         setIsLoading(false);
    //         alert({response?.message})
    //     },
    //     {
    //         onError: (error) => {
    //             console.log(error);

    //         }
    //     }
    // );

// const paymentPage = async (userId)=>{
//       const paymentData = {
//             amount:1,
//             customerEmail:formData?.email,
//             customerPhone:formData?.mobile_number,
//             customerName:formData?.full_name,
//             description:'test description',
//             userId: userId,
//             metadata: {
//               source: 'web',
//               userAgent: navigator.userAgent,
//               timestamp: new Date().toISOString()
//             }
//           };
    
//           const result = await paymentService.initiatePayment(paymentData);
// }


// const useDelegateCreate = siteQueries.useDelegateCreateMutation(
//     async (response) => {
//         try {
//             console.log('Delegate creation response:', response?.data?.user?.id);
            
//             if (response?.message === 'User created successfully') {
//                 const userId = response?.data?.user?.id;
//                 await paymentPage(userId);
//                 return;

//                 // Generate QR code for the newly created user
//                 const qrcode = await qrCreate.mutateAsync({ 
//                     id: response?.data?.user?.id 
//                 });

                
                
//                 // Store QR data in session storage
//                 sessionStorage.setItem('qrdata', JSON.stringify(qrcode));
                
//                 // Navigate to success page
//                 navigate('/atsuccess');
                
//                 console.log("Registration successful");
                
//                 // Reset form data
//                 setFormData({
//                     username: '',
//                     first_name: '',
//                     last_name: '',
//                     email: '',
//                     age: '',
//                     phone: '',
//                     gender: '',
//                     pin_code: '',
//                     platform: null,
//                     country: '',
//                     state: null,
//                     district: null,
//                     dob: '',
//                     address: '',
//                     content: null,
//                     marketing_id: null,
//                     role: 'DELEGATE',
//                 });
                
//                 // Close modal/form
//                 onClose();
//             } else {
//                  const userId = response?.data?.id;
//                 await paymentPage(userId);
//                 // Handle unexpected response
//                 console.warn('Unexpected response:', response?.message);
//                 alert(response?.message || 'Registration failed. Please try again.');
//             }
//         } catch (error) {
//             console.error('Error during delegate creation process:', error);
//             alert('An error occurred during registration. Please try again.');
//         } finally {
//             setIsLoading(false);
//         }
//     },
//     {
//         onError: (error) => {
//             console.error('Delegate creation mutation error:', error);
//             setIsLoading(false);
            
//             // More specific error handling
//             const errorMessage = error?.response?.data?.message || 
//                                error?.message || 
//                                'Registration failed. Please try again.';
//             alert(errorMessage);
//         }
//     }
// );
//     const onSubmit = async (e) => {
//         e.preventDefault();
//         setErrorMessage('');
//         setIsLoading(true)
//         try {
//             const payload = {
//                 username: formData.full_name,
//                 first_name: formData.full_name,
//                 last_name: null,
//                 email: formData.email,
//                 age: null,
//                 phone: formData.mobile_number,
//                 gender: formData.gender,
//                 pin_code: formData.postal_address,
//                 platform: null,
//                 country: formData.nationality,
//                 state: null,
//                 district: null,
//                 dob: formData.date_of_birth,
//                 address: formData.postal_address,
//                 content: null,
//                 marketing_id: null,
//                 id_proof: formData.id_proof || null,
//                 role: formData.delegate_category === 'STUDENT' ? 'STUDENT' : 'DELEGATE',
//             }
//             console.log(payload);
//             await useDelegateCreate.mutateAsync(payload);
//         } catch (error) {
//             setErrorMessage(error.message);
//         } finally {
//             setIsLoading(false);
//         }
//     }

//     const onClose = () => {
//         setIsOpen(false);
//         setCurrentSlide(0);
//         setFormData({
//             full_name: '',
//             date_of_birth: '',
//             gender: '',
//             nationality: '',
//             occupation: '',
//             educational_institution: '',
//             postal_address: '',
//             mobile_number: '',
//             email: '',
//             delegate_category: '',
//             id_proof: null
//         });
//         setErrors({});
//         setErrorMessage('');
//     };

//     const renderField = (field) => {
//         switch (field) {
//             case 'full_name':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Full Name *
//                         </label>
//                         <input
//                             type="text"
//                             name="full_name"
//                             value={formData.full_name}
//                             onChange={handleInputChange}
//                             className={`w-full px-4 py-2 rounded-lg border ${errors.full_name ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-200 focus:border-blue-500`}
//                             placeholder="Enter your full name"
//                             required
//                         />
//                         {errors.full_name && (
//                             <p className="text-red-500 text-xs mt-1">⚠️ {errors.full_name}</p>
//                         )}
//                     </div>
//                 );
//             case 'date_of_birth':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Date of Birth *
//                         </label>
//                         <input
//                             type="date"
//                             name="date_of_birth"
//                             value={formData.date_of_birth}
//                             onChange={handleInputChange}
//                             className={`w-full px-4 py-2 rounded-lg border ${errors.date_of_birth ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-200 focus:border-blue-500`}
//                         // required
//                         />
//                         {errors.date_of_birth && (
//                             <p className="text-red-500 text-xs mt-1">⚠️ {errors.date_of_birth}</p>
//                         )}
//                     </div>
//                 );
//             case 'gender':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Gender *
//                         </label>
//                         <div className="flex flex-col space-y-2">
//                             {['MALE', 'FEMALE', 'OTHER'].map(gender => (
//                                 <label key={gender} className="inline-flex items-center">
//                                     <input
//                                         type="radio"
//                                         name="gender"
//                                         value={gender}
//                                         checked={formData.gender === gender}
//                                         onChange={handleInputChange}
//                                         className="form-radio h-4 w-4 text-blue-600"
//                                     />
//                                     <span className="ml-2 text-gray-700 capitalize">{gender.toLowerCase()}</span>
//                                 </label>
//                             ))}
//                         </div>
//                         {errors.gender && (
//                             <p className="text-red-500 text-xs mt-1">⚠️ {errors.gender}</p>
//                         )}
//                     </div>
//                 );
//             case 'nationality':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Nationality
//                         </label>
//                         <input
//                             type="text"
//                             name="nationality"
//                             value={formData.nationality}
//                             onChange={handleInputChange}
//                             className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
//                             placeholder="Your nationality"
//                         />
//                     </div>
//                 );
//             case 'occupation':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Occupation
//                         </label>
//                         <input
//                             type="text"
//                             name="occupation"
//                             value={formData.occupation}
//                             onChange={handleInputChange}
//                             className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
//                             placeholder="Your occupation"
//                         />
//                     </div>
//                 );
//             case 'educational_institution':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Educational Institution (if applicable)
//                         </label>
//                         <input
//                             type="text"
//                             name="educational_institution"
//                             value={formData.educational_institution}
//                             onChange={handleInputChange}
//                             className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
//                             placeholder="School/College/University"
//                         />
//                     </div>
//                 );
//             case 'postal_address':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Postal Address
//                         </label>
//                         <textarea
//                             name="postal_address"
//                             value={formData.postal_address}
//                             onChange={handleInputChange}
//                             className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
//                             placeholder="Your complete postal address"
//                             rows="3"
//                         />
//                     </div>
//                 );
//             case 'mobile_number':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Mobile Number *
//                         </label>
//                         <input
//                             type="tel"
//                             name="mobile_number"
//                             value={formData.mobile_number}
//                             onChange={handleInputChange}
//                             className={`w-full px-4 py-2 rounded-lg border ${errors.mobile_number ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-200 focus:border-blue-500`}
//                             placeholder="Enter mobile number"
//                             required
//                         />
//                         {errors.mobile_number && (
//                             <p className="text-red-500 text-xs mt-1">⚠️ {errors.mobile_number}</p>
//                         )}
//                     </div>
//                 );
//             case 'email':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Email Address
//                         </label>
//                         <input
//                             type="email"
//                             name="email"
//                             value={formData.email}
//                             onChange={handleInputChange}
//                             className={`w-full px-4 py-2 rounded-lg border ${errors.email ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-200 focus:border-blue-500`}
//                             placeholder="Enter email address"
//                         />
//                         {errors.email && (
//                             <p className="text-red-500 text-xs mt-1">⚠️ {errors.email}</p>
//                         )}
//                     </div>
//                 );
//             case 'delegate_category':
//                 return (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Delegate Category *
//                         </label>
//                         <div className="space-y-2">
//                             <label className="flex items-center">
//                                 <input
//                                     type="radio"
//                                     name="delegate_category"
//                                     value="DELEGATE"
//                                     checked={formData.delegate_category === 'DELEGATE'}
//                                     onChange={handleInputChange}
//                                     className="form-radio h-4 w-4 text-blue-600"
//                                     required
//                                 />
//                                 <span className="ml-2 text-gray-700">General Public – ₹500</span>
//                             </label>
//                             <label className="flex items-center">
//                                 <input
//                                     type="radio"
//                                     name="delegate_category"
//                                     value="STUDENT"
//                                     checked={formData.delegate_category === 'STUDENT'}
//                                     onChange={handleInputChange}
//                                     className="form-radio h-4 w-4 text-blue-600"
//                                 />
//                                 <span className="ml-2 text-gray-700">Student – ₹250</span>
//                             </label>
//                         </div>
//                         {errors.delegate_category && (
//                             <p className="text-red-500 text-xs mt-1">⚠️ {errors.delegate_category}</p>
//                         )}
//                     </div>
//                 );
//             case 'id_proof':
//                 return formData.delegate_category === 'STUDENT' && (
//                     <div className="mb-4">
//                         <label className="block text-gray-800 text-sm font-medium mb-1">
//                             Upload Student ID *
//                         </label>
//                         <input
//                             type="file"
//                             name="id_proof"
//                             onChange={handleFileChange}
//                             className={`w-full px-4 py-2 rounded-lg border ${errors.id_proof ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-200 focus:border-blue-500`}
//                             accept=".pdf,.jpg,.jpeg,.png"
//                         />
//                         {errors.id_proof && (
//                             <p className="text-red-500 text-xs mt-1">⚠️ {errors.id_proof}</p>
//                         )}
//                     </div>
//                 );
//             default:
//                 return null;
//         }
//     };

    return (
        <div className="relative delegateForm">
            {/* <button
                onClick={() => setIsOpen(true)}
                className="bg-[#efc847] text-white font-medium py-2 px-4 rounded-2xl shadow transition-colors"
            // className="block w-full text-center bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition-colors"

            >
                Delegate Registration
            </button> */}
            <button
                // onClick={() => setIsOpen(true)}
                onClick={() => navigate(RouteConstants.REGISTRATIONFORM)}
                className="flex h-[56px] w-[270px] scale-90 p-1 items-center pl-2 gap-2 bg-[#efc847] hover:bg-[#f0872a87] text-black text-[20px] font-normal rounded-full">
                <img src={PenLogo} alt="Pen Icon" className="w-11 h-11 object-contain" />
                Delegate Registration
            </button>

            {/* {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 delegate">
                    <div className="relative bg-blue-50 rounded-xl shadow-xl overflow-hidden w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                        <div className="bg-blue-100 px-6 py-4 flex justify-between items-center border-b border-gray-200">
                            <h3 className="text-xl font-bold text-gray-800">
                                Delegate Registration
                            </h3>
                            <button
                                onClick={onClose}
                                className="text-gray-500 hover:text-gray-700 text-2xl"
                            >
                                <FaTimes />
                            </button>
                        </div>

                        <div className="flex justify-center space-x-4 py-3 bg-gray-200">
                            {slides.map((slide, index) => (
                                <button
                                    key={slide.id}
                                    onClick={() => setCurrentSlide(index)}
                                    className={`rounded-full justify-center border border-gray-500 transition-all ${index === currentSlide ? 'w-3 h-3  bg-blue-600' : 'w-2 h-2 bg-black'}`}

                                />
                            ))}
                        </div>

                        <div className="p-6">
                            {errorMessage && (
                                <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-3 mb-4 rounded flex justify-between items-center">
                                    <span>⚠️ {errorMessage}</span>
                                    <button
                                        onClick={() => setErrorMessage('')}
                                        className="text-red-700 hover:text-red-900"
                                    >
                                        ×
                                    </button>
                                </div>
                            )}

                            <form onSubmit={onSubmit}>
                                <div className="mb-6">
                                    <h4 className="text-gray-800 text-lg font-semibold mb-4">
                                        {slides[currentSlide].title}
                                    </h4>
                                    <div className="space-y-4">
                                        {slides[currentSlide].fields.map(field => renderField(field))}
                                    </div>
                                </div>

                                <div className="flex justify-between mt-6">
                                    {currentSlide !== 0 ? (
                                        <button
                                            type="button"
                                            onClick={prevSlide}
                                            className="flex items-center px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                                        >
                                            <FaChevronLeft className="mr-2" /> Previous
                                        </button>
                                    ) : (<div />)}

                                    {currentSlide < slides.length - 1 ? (
                                        <button
                                            type="button"
                                            onClick={nextSlide}
                                            className="flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
                                        >
                                            Next <FaChevronRight className="ml-2" />
                                        </button>
                                    ) : (
                                        <button
                                            type="submit"
                                            disabled={isLoading}
                                            className="flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg"
                                        >
                                            {isLoading ? (
                                                <span>Processing...</span>
                                            ) : (
                                                <span>Submit Registration</span>
                                            )}
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )} */}
        </div>
    );
};

export default DelegateRegistration;
